import axios from 'axios'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Getrequest } from './AxiosRequest';
import  jwtDecode  from "jwt-decode";



export const ContextData = createContext()


      
function Context({children}) {


    const navigate = useNavigate();



    const [Tokens,setTokens] = useState("")
    const [RefreshUesFF,setRefreshUesFF] = useState(true)
    const [UpdateAmount,setUpdateAmount] = useState("")
    const [readStatus,setreadStatus] = React.useState(true)
    const [UserTokens,setUserTokens] = useState("")
    const [ReloadBioForms,setReloadBioForms] = useState(false)
    const [BioProgressStatus,setBioProgressStatus] = useState(0)
    const [ParentProgressStatus,setParentProgressStatus] = useState(0)
    const [GlobalLoader,setGlobalLoader] = useState(true)
    const [accesstoken,setaccesstoken] = useState(null)
    const [Allow,setAllow] = useState(false)
    const [Value, setValue] = React.useState('');
    const [Data,setData] = React.useState([]);
    const [ChangeLoanForm,setChangeLoanForm] = useState("")
   






 useEffect(()=>{
    
    if(UserTokens){


        async function FetchData(){

    const response = await Getrequest(`/auth/get_app_type/${UserTokens}`,accesstoken)
        
       
          setValue(response[0]?.application_type)
        
          

}
    
FetchData()

    }

    // Get a new access token if missing
  

},[Value,accesstoken])
   

   React.useEffect(()=>{

                async function FetchData() {
                     const response = await Getrequest(`auth/get_upload_doc_applicant/${UserTokens}`,accesstoken)
                      setData(response)

                      
                }

              FetchData()


  },[]);



  return (
    <ContextData.Provider
    value={{
      Tokens,setTokens,
      RefreshUesFF,setRefreshUesFF,
      UpdateAmount,setUpdateAmount,
      readStatus,setreadStatus,
      UserTokens,setUserTokens,
      ReloadBioForms,setReloadBioForms,
      BioProgressStatus,setBioProgressStatus,
      ParentProgressStatus,setParentProgressStatus,
      GlobalLoader,setGlobalLoader,
      accesstoken,setaccesstoken,
      Allow,setAllow,
      Value, setValue,
      ChangeLoanForm,setChangeLoanForm
     } }
    > 
    {children}
    </ContextData.Provider>
  )
}

export default Context